<template>
  <v-text-field
    :label="label"
    v-model="pass"
    :type="show ? 'text' : 'password'"
    prepend-icon="mdi-lock"
    :append-icon="show ? 'mdi-eye-off' : 'mdi-eye'"
    required
    :error-messages="errorMessages"
    @input="updatePass"
    @blur="$emit('blurPass')"
    @click:append="show = !show"
  ></v-text-field>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: "Mot de passe",
    },
    value: {
      type: String,
      required: true,
    },
    errorMessages: {
      type: Array,
    },
  },
  data() {
    return {
      show: false,
      pass: "",
    };
  },
  methods: {
    updatePass() {
      this.$emit("input", this.pass);
    },
  },
  watch: {
    value() {
      this.pass = this.value;
    },
  },
};
</script>

<style></style>
